/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_RbacInputs */

const en_admin_nav_rbac = /** @type {(inputs: Admin_Nav_RbacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RBAC`)
};

/**
* | output |
* | --- |
* | "RBAC" |
*
* @param {Admin_Nav_RbacInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_nav_rbac = /** @type {((inputs?: Admin_Nav_RbacInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_RbacInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_nav_rbac(inputs)
});
export { admin_nav_rbac as "admin.nav.rbac" }